import { Instagram, Youtube, Facebook, Twitter, Linkedin, Music2, Globe } from "lucide-react";

export function socialLinksOf(s) {
  if (Array.isArray(s?.social_links)) return s.social_links.filter((l) => l && l.url);
  return [s?.instagram_url, s?.instagram_url_2].filter(Boolean).map((url) => ({ label: "Instagram", url }));
}

export function socialIcon(url) {
  let host = "";
  try {
    host = new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return Globe;
  }
  if (host.includes("instagram.")) return Instagram;
  if (host.includes("youtube.") || host === "youtu.be") return Youtube;
  if (host.includes("tiktok.")) return Music2;
  if (host.includes("facebook.") || host === "fb.com") return Facebook;
  if (host === "x.com" || host.includes("twitter.")) return Twitter;
  if (host.includes("linkedin.")) return Linkedin;
  return Globe;
}
